/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthGameData, FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthGameDataFromJSONTyped, FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthGameDataToJSON, } from './FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthGameData';
export function FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataGameDataFromJSON(json) {
    return FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataGameDataFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataGameDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthGameData(json)) {
        return FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthGameDataFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataGameDataToJSON(json) {
    return FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataGameDataToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataGameDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthGameData(value)) {
        return FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthGameDataToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataGameData.js.map